import { PagePersonal } from './Personal';
import { PLATFORMS } from './Platforms';

export const USER = {
  ...PLATFORMS,
  Personal: PagePersonal,
} as const;
